import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import ClipLoader from "react-spinners/ClipLoader";
import Product from './Smartphone/Smartphone';
import { Box, Button, FormControl, InputAdornment, Menu, MenuItem, Stack, TextField, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import Sidebar from '../Sidebar/Sidebar';
import { useGetAllBrandsQuery, useGetAllColorsQuery, useGetAllActiveSmartphonesQuery, useGetAllStoragesQuery, useGetAllInactiveSmartphonesQuery } from '../../../features/fullApi';
import { useSelector } from 'react-redux';
import './smartphones.css'
import { useTheme } from '@mui/material/styles';
import Error500 from '../../ErrorPages/Error500';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import '../../../App.css'
import '../autocomplete.css'
import PaginationComp from '../Pagination/PaginationComp';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { DisplaySettings } from '@mui/icons-material';

const Container = styled.div`
   margin-top: 20px;
`;

const MobileContainer = styled.div`
  margin-top: 180px;
`;


const Products = () => {
  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }

  const params = useParams()
  window.scrollTo(0, 0);
  //#################################
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //#################################

  const {data, error, isLoading} = useGetAllActiveSmartphonesQuery();
  const {data: dataInactive, error: errorInactive, isLoading: isLoadingInactive} = useGetAllInactiveSmartphonesQuery();


  const [resetFilter, setResetFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(params.page - 1)

  //!constructing the brands/storages/colors key value array with id:name
  const {data:brands, errorBrands, isLoadingBrands} = useGetAllBrandsQuery();
  let brandsArr = []
  brands?.map(brand => {
    brandsArr[brand._id] = brand.brandName
  })

  const {data:storages, errorStorages, isLoadingStorages} = useGetAllStoragesQuery();
  let storagesArr = []
  storages?.map(storage => {
    storagesArr[storage._id] = storage.storageName
  })

  const {data:colors, errorColors, isLoadingColors} = useGetAllColorsQuery();
  let colorsArr = []
  colors?.map(color => {
    colorsArr[color._id] = color.colorName
  })
  //!constructing the brands key value array with id:name

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  let productsPerPage

  if(isXs || isSm) {
    productsPerPage = 16
  } else if(isMd) {
    productsPerPage = 24
  } else {
    productsPerPage = 32
  }

  const pagesVisited = pageNumber * productsPerPage
  const [act, setAct] = useState(true)

  useEffect(() => {
    navigate(`/smartphones/${pageNumber + 1}`)
    sessionStorage.setItem('pageNumber', pageNumber)
    if(filtered) {
      setDisplayProducts(filteredProducts?.slice(pagesVisited, pagesVisited + productsPerPage))
    } else {
      setDisplayProducts(data?.slice(pagesVisited, pagesVisited + productsPerPage))
    }
  }, [pageNumber])


  const [displayProducts, setDisplayProducts] =  useState([])
  
  const [pageCount, setPageCount] = useState(0)

  const [filteredProducts, setFilteredProducts] = useState([])

  const handleFilterProducts = (filteredProducts) => {
    if(!isSm) {
      setFiltered(true)
      setPageCount(Math.ceil(filteredProducts?.length / productsPerPage))
      setDisplayProducts(filteredProducts?.slice(pagesVisited, pagesVisited + productsPerPage))
      setFilteredProducts(filteredProducts)
    }
  }

  useEffect(() => {
    if(!isLoading && !isLoadingInactive) {
      if(!act) {
        setDisplayProducts(dataInactive?.slice(pagesVisited, pagesVisited + productsPerPage))
        setPageCount(Math.ceil(dataInactive?.length / productsPerPage))
      } else {
        setDisplayProducts(data?.slice(pagesVisited, pagesVisited + productsPerPage))
        setPageCount(Math.ceil(data?.length / productsPerPage))
      }
  }}, [isLoading, isLoadingInactive, act, data, dataInactive])

 console.log("DISPLAY PRODUCTS", displayProducts)


  const [hitted, setHitted] = useState(false)
  const [filtered, setFiltered] = useState(false)
  const [rerender, setRerender] = useState(false)


  const clearSearch = () => {
    const resetSearch = async () => {
     setSearch("")
    };

    resetSearch()
  }

  useEffect(() => {

  }, [rerender])

  const [showSidebar, setShowSidebar] = useState(false)

  const navigate = useNavigate()

  const handleStatus = (event, newStatus) => {
    if (newStatus !== null) {
      if(newStatus === "Active") {
        setAct(true)
      } else {
        setAct(false)
      }
    }
  };

  const StackSelect = () => (
    <Stack direction="row" style={{display: 'flex', justifyContent: 'center', alignCenter: 'center', marginBottom:'20px'}}>
    <ToggleButtonGroup
      value={act}
      exclusive
      onChange={handleStatus}
      aria-label="text alignment"
    >
      <ToggleButton value="Active">
        <CheckIcon style={{color: 'green'}} />
      </ToggleButton>
      <ToggleButton value="Inactive">
        <CloseIcon style={{color: 'red'}}/>
      </ToggleButton>
    </ToggleButtonGroup>
  </Stack>
  )


  const renderMobileProducts = () => (
    <>
    <div>
      {act ? (
      <div>
        {isLoadingInactive ? (
          <div className="flexCenter" style={{height: 'calc(100vh - 130px)'}}>
            <ClipLoader
              color="#93032E"
              loading={isLoadingInactive}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>      
        ) : errorInactive ? (<Error500></Error500>)
        :(<>
          <MobileContainer>
            <div id={showSidebar ? "sidebarShow" : "hideSidebar"}>{user?._id &&
                <Sidebar type={"smartphone"} handleFilterProducts={handleFilterProducts} showSidebar={showSidebar} setShowSidebar={setShowSidebar} resetFilter={resetFilter}/>}
            </div>
            <MobileContainer>
            <div style={{position: 'fixed', top: '0', zIndex:"200", marginTop: '110px', padding:'10px 0', backgroundColor:"#fff", display: 'flex', justifyContent: 'space-around', width: '100%'}}>
              <Button style={{width: '150px', fontSize: "12px"}} color="primary" variant="contained" onClick={() => setShowSidebar(true)}>Show filters</Button>
              {user?.isAdmin &&
              (
              <>
                <Button variant="contained" color="secondary" style={{width: '150px', fontSize: "12px"}} onClick={() => navigate("/smartphone/create")}>Add Smartphone</Button>
              </>
              )
              }
            </div>
          </MobileContainer>

          </MobileContainer>

            <MobileContainer>
              <h3 style={{textAlign: 'center'}}>Smartphones</h3>
              {user?.isAdmin && <StackSelect/> }
              <Grid container rowSpacing={2} columnSpacing={1} className="gridClass">
                {(filteredProducts?.length > 0 ) &&
                <>
                  {filteredProducts?.filter((product) => {
                    return search.toLowerCase() === '' ? product : product.title.toLowerCase().includes(search)
                  }).map((product) => (
                    <Grid key={product._id} item xs={6} lg={4} xl={2}>
                      <Product product={product}/>
                    </Grid>
                  ))}
                </>
                }
                {!hitted &&
                <>
                  {search ? (
                  <>
                    {dataInactive?.map((product) => (
                        <Grid key={product._id} item xs={6} lg={3} xl={2}>
                          <Product product={product}/>
                        </Grid>
                      ))}
                  </>
                  ) : (
                    <>
                    {displayProducts?.map((product) => (
                      <Grid key={product._id} item xs={6} lg={3} xl={2}>
                        <Product product={product}/>
                      </Grid>
                    ))}
                  </>
                  )
                  }
                    <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
                </>}
                <div>
                  {(filteredProducts?.length === 0 && hitted) && 
                  <h3>
                    No products found for your search
                  </h3>}
                </div>
              </Grid>
            </MobileContainer>
          </>
        )
      }
      </div>) : (
              <div>
              {isLoading ? (
                <div className="flexCenter" style={{height: 'calc(100vh - 130px)'}}>
                  <ClipLoader
                    color="#93032E"
                    loading={isLoading}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </div>      
              ) : error ? (<Error500></Error500>)
              :(<>
                <MobileContainer>
                  <div id={showSidebar ? "sidebarShow" : "hideSidebar"}>{user?._id &&
                      <Sidebar handleFilterProducts={handleFilterProducts} showSidebar={showSidebar} setShowSidebar={setShowSidebar} resetFilter={resetFilter}/>}
                  </div>
                  <MobileContainer>
                  <div style={{position: 'fixed', top: '0', zIndex:"200", backgroundColor:"#fff", marginTop: '110px', padding:'10px 0', display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                    <Button style={{width: '150px', fontSize: "12px"}} color="primary" variant="contained" onClick={() => setShowSidebar(true)}>Show filters</Button>
                    {user?.isAdmin &&
                    (
                    <Button variant="contained" color="secondary" style={{width: '150px', fontSize: "12px"}} onClick={() => navigate("/smartphone/create")}>Add Smartphone</Button>
                    )
                    }
                  </div>
                </MobileContainer>
      
                </MobileContainer>
      
                  <MobileContainer>
                    <h3 style={{textAlign: 'center'}}>Smartphones</h3>
                    {user?.isAdmin && <StackSelect/> }
                    <Grid container rowSpacing={2} columnSpacing={1}>
                      {(filteredProducts.length > 0 ) &&
                      <>
                        {filteredProducts.map((product) => (
                          <Grid key={product._id} item xs={6} lg={3} xl={2}>
                            <Product product={product}/>
                          </Grid>
                        ))}
                      </>}
                      {!hitted &&
                      <>
                        {search ? (
                        <>
                          {data?.filter((product) => {
                              return search.toLowerCase() === '' ? product : product.title.toLowerCase().includes(search)
                            }).map((product) => (
                              <Grid key={product._id} item xs={6} lg={3} xl={2}>
                                <Product product={product}/>
                              </Grid>
                            ))}
                        </>
                        ) : (
                          <>
                          {displayProducts?.filter((product) => {
                            return search.toLowerCase() === '' ? product : product.title.toLowerCase().includes(search)
                          }).map((product) => (
                            <Grid key={product._id} item xs={6} lg={3} xl={2}>
                              <Product product={product}/>
                            </Grid>
                          ))}
                      </>
                        )
                        }
                        <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
                      </>}
                      <div>
                        {(filteredProducts.length === 0 && hitted) && 
                        <h3>
                          No products found for your search
                        </h3>}
                      </div>
                    </Grid>
                  </MobileContainer>
                </>
              )
            }
            </div>
      )}
    </div>
    </>
  )

  const renderTabletProducts = () => (
    <div>
    {isLoading ? (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    ) 
    : error ? (<Error500></Error500>)
    :(
      <>
      <Container style={{display: 'flex', justifyContent: 'space-between'}}>
        <div style={{marginTop: '64px'}}>{user?._id &&
            <Sidebar handleFilterProducts={handleFilterProducts} resetFilter={resetFilter}/>}
        </div>
        <div id="filterContainer">
          <TextField variant="outlined" size="small" placeholder="search product by name" onChange={(e) => setSearch(e.target.value)} value={search} id="searchInput" style={{backgroundColor: '#fff'}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {
                    search === "" ? (
                      <SearchIcon className="iconClass" />
                    ) : (<ClearIcon className="iconClass" onClick={clearSearch}/>)
                  }
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div>
          {user?.isAdmin &&
                (
                    <div>
                    <Button
                      id="demo-positioned-button"
                      aria-controls={open ? 'demo-positioned-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                    >
                      Dashboard
                    </Button>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <MenuItem onClick={handleClose}>Profile</MenuItem>
                      <MenuItem onClick={handleClose}>My account</MenuItem>
                      <MenuItem onClick={handleClose}>Logout</MenuItem>
                    </Menu>
                  </div>
                )
          }
        </div>
      </Container>

        <Container>
          <Grid container justify="center" spacing={10} className="gridClass">
            {(filteredProducts?.length > 0 ) &&
            <>
              {filteredProducts.map((product) => (
                <Grid key={product._id} item>
                  <Product product={product}/>
                </Grid>
              ))}
            </>}
            {!hitted &&
            <> 
                {displayProducts?.filter((product) => {
                   return search.toLowerCase() === '' ? product : product.title.toLowerCase().includes(search)
                 }).map((product) => (
                   <Grid key={product._id} item>
                     <Product product={product}/>
                   </Grid>
                 ))}
             </>    
            }
         
         <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
          </Grid>
        </Container>
      </>
    )
  }
  </div>
  )

  const renderDesktopProducts = () => (
    <>
    <div style={{width: '1200px', margin: '0 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
    <div>
    {user?.isAdmin &&
              (
              <div style={{display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center', marginTop:'50px'}}>
                <div>
                  <Button variant="contained" style={{width: '200px', marginBottom: '30px'}} onClick={() => navigate("/smartphone/create")}>Create Smartphone</Button>
                </div>
                <div>
                  <StackSelect/>
                </div>
              </div>
            )
    }
    </div>
    {(isLoading) ? (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    ) 
    : (error) ? (<Error500></Error500>)
    :(
      <>
        <Container style={{display: 'flex', flexDirection:'column'}}>
          <div style={{marginBottom:'50px'}}>
            <h1 style={{textAlign:'center'}}>Smartphones</h1>
          </div>
          <div style={{display:'flex'}}>
          <Sidebar type={"smartphone"} handleFilterProducts={handleFilterProducts} resetFilter={resetFilter}/>
          <Box sx={{ flexGrow: 1 }}>
          <Grid container>
              <>
              <>
                 {displayProducts?.map((product) => (
                  <Grid key={product._id} item>
                    <Product product={product}/>
                  </Grid>
                ))}
              </>

              {/* <>
                {filteredProducts.map((product) => (
                  <Grid key={product._id} item>
                    <Product product={product}/>
                  </Grid>
                ))}
              </>   */}

     
        <Container style={{width:'100%'}}>
        {pageCount !== 1 &&
          <PaginationComp 
          pageCount={pageCount} 
          paramsPage={params.page} 
          pageNumber={pageNumber} 
          setPageNumber={setPageNumber}/>
        }
        </Container>
              </>
          </Grid>
          </Box>  
          </div>
        </Container>

   
      </>
    )
  }
  </div>
  </>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileProducts() : 
        (isSm) ? renderMobileProducts() :
        (isMd) ? renderTabletProducts() :
        renderDesktopProducts()
      }
    </div>
  );
};

export default Products;